function ProductVariantText({ value, option, onSelect, isSelected, isDisabled }) {
  const className = [
    'rounded border border-neutral-400 px-4 py-[7px] text-xs-medium lg:text-xs text-neutral-700 hover:border-neutral-700',
    isSelected && '!border-neutral-700 text-neutral-900',
    isDisabled && 'variant-selector-disabled'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button type="button" name={value} onClick={() => onSelect(value, option)} aria-label={value} className={className}>
      {value}
    </button>
  )
}

export default ProductVariantText
